export const GUARDIAN = {
    MANAGE_PERSON: {
        POST_PLACE:"/guardian/manage/find-by-code-place",
        REGISTER_PERSON: "/guardian/manage/save-person",
        REGISTER_VEHICLE: "/guardian/manage/save-vehicle",
        GET_VEHICLE_TYPE: "/guardian/manage/vehicle-type",
    }
};